import { createContext } from 'react';

export const DropdownContext = createContext({
  dropdownId: null,
  visible: false,
});
